import { Component, OnInit, inject } from '@angular/core';

import { Link } from './link';
import { RouterModule } from '@angular/router';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  featherShoppingCart,
  featherUsers,
  featherUser,
  featherActivity,
  featherBookOpen,
  featherBook,
} from '@ng-icons/feather-icons';
import {
  heroDocumentText,
  heroCalendarDays,
  heroUserGroup,
} from '@ng-icons/heroicons/outline';
import { AuthService } from '@coworkrz/auth/data-access';
import { User } from '@coworkrz/users/types';
import {
  AdminButtonComponent,
  AvatarComponent,
  MenuComponent,
  MenuTriggerForDirective,
} from '@coworkrz/shared/ui';
import { LOCATION_TOKEN } from '@coworkrz/shared/misc';

@Component({
  selector: 'app-admin-sidebar',
  imports: [
    RouterModule,
    NgIconComponent,
    AvatarComponent,
    AdminButtonComponent,
    MenuTriggerForDirective,
    MenuComponent,
  ],
  providers: [
    provideIcons({
      featherShoppingCart,
      featherActivity,
      featherUsers,
      featherUser,
      heroDocumentText,
      heroCalendarDays,
      heroUserGroup,
      featherBookOpen,
      featherBook,
    }),
  ],
  templateUrl: './admin-sidebar.component.html',
})
export class AdminSidebarComponent implements OnInit {
  private auth = inject(AuthService);
  private location = inject<Location>(LOCATION_TOKEN);

  links: Link[] = [
    {
      icon: 'featherActivity',
      label: 'Dashboard',
      link: 'dashboard',
    },
    {
      icon: 'featherShoppingCart',
      label: 'Add to cart',
      link: 'cart',
    },
    {
      icon: 'featherUser',
      label: 'Sessions',
      link: 'sessions',
    },
    {
      icon: 'featherUsers',
      label: 'Members',
      link: 'members',
    },
    {
      icon: 'heroUserGroup',
      label: 'Teams',
      link: 'teams',
    },
    {
      icon: 'heroDocumentText',
      label: 'Invoices',
      link: 'invoices',
    },
    {
      icon: 'featherBookOpen',
      label: 'Products',
      link: 'products',
    },
    {
      icon: 'featherBook',
      label: 'Reservations',
      link: 'reservations',
    },
  ];

  user: User | null = null;

  ngOnInit(): void {
    this.auth.loadUser().subscribe({
      next: (user) => (this.user = user),
    });
  }

  signOut(): void {
    this.auth.signOut();
    this.location.assign('/');
  }
}
